<template>
  <b-col class="py-2" sm="12" md="8">
    <OrderSection
      :prod="product"
      v-on:change-product="changeProduct"
      :modal="modal"
      :initial_product="selectedOption"
      :key="selectedOption"
    />
    <hr />
    <DetailsSection :prod="selectedProduct" />
  </b-col>
</template>

<script>
import OrderSection from "./OrderSection";
import DetailsSection from "./DetailsSection";

export default {
  name: "ProductDetails",
  props: ["product", "modal", "initial_product"],
  created() {},
  data() {
    return {
      selectedOption: "",
    };
  },
  computed: {
    selectedProduct: function () {
      if (this.product.sizes) {
        return this.product.sizes.find(
          (item) => item.Item_id == this.selectedOption
        );
      } else if (this.product.colors) {
        return this.product.colors.find(
          (item) => item.Item_id == this.selectedOption
        );
      }
      return this.prod;
    },
  },
  mounted() {
    this.selectedOption = this.initial_product;
  },
  methods: {
    changeProduct: function (Item_id) {
      this.selectedOption = Item_id;
      this.$emit("change-product", this.selectedProduct);
    },
  },
  components: {
    OrderSection,
    DetailsSection,
  },
};
</script>

<style></style>
